// Cliente baterías — POST al backend. Caché local 7 días.
// Si el remoto falla, el catálogo curado (constants) alimenta el modelado.

import { hubPost } from './hub';
import { DEFAULT_BATTERIES } from '../constants';

const CACHE_PREFIX = 'batt:';
const CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function readCache(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (Date.now() - p.t > CACHE_TTL_MS) return null;
    return p.d;
  } catch { return null; }
}

function writeCache(key, data) {
  try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data })); } catch {}
}

export async function searchBatteries(q = '', arch = '', limit = 50) {
  const key = `${CACHE_PREFIX}${q}:${arch}:${limit}`;
  const cached = readCache(key);
  if (cached?.items?.length) return { ...cached, cached: true };

  let data;
  try {
    data = await hubPost('batteries', { q, arch, limit });
  } catch {
    data = null;
  }
  if (data?.items?.length) {
    writeCache(key, { ...data, cached: false });
    return data;
  }
  const t = (q || '').trim().toLowerCase();
  const items = DEFAULT_BATTERIES
    .filter((b) => !t || `${b.brand} ${b.model} ${b.chemistry || ''} ${b.familia || ''}`.toLowerCase().includes(t))
    .filter((b) => {
      if (!arch) return true;
      const a = String(arch).toLowerCase();
      if (a === 'lv-48v' || a === '48') return Number(b.voltage) <= 60;
      if (a === 'hv' || a === 'bess') return Number(b.voltage) >= 150 || (b.familia || '') === 'bess';
      if (a === 'gel' || a === 'litio') return (b.familia || '') === a || (b.chemistry || '').toLowerCase() === a;
      return String(b.voltage) === String(arch);
    })
    .slice(0, limit)
    .map((b) => ({
      id: b.id, brand: b.brand, model: b.model, chemistry: b.chemistry,
      familia: b.familia || null,
      kwh: b.kwh, usableKwh: b.kwh * (b.dod || 1), v: b.voltage, dod: b.dod,
      cycles: b.cycles,
      source: 'catálogo curado ALEBAS (respaldo)',
    }));
  return { ok: true, items, total: items.length, source: 'respaldo' };
}
